import { Component, Input, Output, EventEmitter } from '@angular/core';
import { isSafari } from '@app/shared/helpers/environment';
@Component({
  selector: 'app-smash-spinner',
  templateUrl: './smash-spinner.component.html',
  styleUrls: ['./smash-spinner.component.scss']
})
export class SmashSpinnerComponent {

  @Input() url: string;
  @Input() waveColor: string;
  @Input() borderRadius = '50%';
  @Input() longpress = false;

  @Output() triggerActionAfterHolding: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() imageLoading: EventEmitter<boolean> = new EventEmitter();
  @Output() readyToDisplayImage: EventEmitter<boolean> = new EventEmitter();

  fallbackUrlLogo = 'assets/img/smash-logo/png/icono-chip-full-white.png';
  isSafari = isSafari();

  onClick(event) {
    this.triggerActionAfterHolding.emit(true);
  }

  displayLoadingSpinner() {
    this.imageLoading.emit(true);
  }

  hideLoadingSpinner() {
    this.readyToDisplayImage.emit(true);
  }

}
